module.exports = __webpack_public_path__ + "static/media/team--sarah.50f41e2b.jpg";